import dynamic from 'next/dynamic';
import { ActiveDialogOnPageEnum } from 'src/researcher/context/ui/dialog.types';
import { TextDialogWithCircularProgress } from 'src/researcher/component/common';
import React from 'react';
import { useDialogState } from 'src/researcher/context/ui/dialog';
import { CopyDialog } from './CopyAllBtn';

const FallbackDialog = () => <TextDialogWithCircularProgress message="" />;

const PremiumUpsellModal = dynamic(() => import('src/researcher/component/PremiumUpsellModal'), {
  ssr: false,
  loading: FallbackDialog,
});
const MoveToTrashModal = dynamic(
  () => import('src/researcher/component/editorBox/MoveToTrashModal'),
  {
    ssr: false,
    loading: FallbackDialog,
  }
);

const LoadingDialog = () => <TextDialogWithCircularProgress message="Loading..." />;

const DIALOG_NAME_TO_COMPONENT_MAP = {
  /**
   * If you need lazy loaded just wrap the component lazy loaded  in component fn
   * then put that entry here
   */
  [ActiveDialogOnPageEnum.CREATING_DIALOG]: LoadingDialog,
  [ActiveDialogOnPageEnum.RESTORING_DIALOG]: LoadingDialog,
  [ActiveDialogOnPageEnum.LOADING_DIALOG]: LoadingDialog,
  [ActiveDialogOnPageEnum.PREMIUM_UPSEL_DIALOG]: PremiumUpsellModal,
  [ActiveDialogOnPageEnum.MOVE_TO_TRASH_DIALOG]: MoveToTrashModal,
  [ActiveDialogOnPageEnum.COPY_DIALOG]: CopyDialog,
  [ActiveDialogOnPageEnum.NO_DIALOG]: null,
};

export function ActiveDialog() {
  const { dialog, props } = useDialogState();
  const Component = DIALOG_NAME_TO_COMPONENT_MAP[
    dialog as keyof typeof DIALOG_NAME_TO_COMPONENT_MAP
  ] as React.FC<any> | null;

  return dialog && Component ? <Component {...props} /> : null;
}
